import React,{useState,useEffect} from 'react'
import Loading from '../../../common/Loading'
import {toast} from 'react-toastify'
import settingsService from '../../../../services/settings.service'
import { useEyeconxStore } from '../../../../store/eyeconxStore'
import ClinicInfoForm from './ClinicInfoForm'
import ClinicInfoText from './ClinicInfoText'

function ClinicInfo() {
  const [isEditing,setIsEditing] = useState(false)
  const [isLoading,setIsLoading] = useState(false)
  const [clinicInfo,setClinicInfo] = useState(null)
  const clinicId = useEyeconxStore(state => state.user.clinicId)

  useEffect(()=>{
        //getClinicInfo
        getClinicInfo()
  },[clinicId])

  const getClinicInfo = ()=>{
    setIsLoading(true)
    settingsService.getClinicById(clinicId)
    .then(res=>{
        setClinicInfo(res.data)
        setIsLoading(false)
    })
    .catch(err=>{
        console.log("Error while getting Clinic Info")
        setIsLoading(false)
    })
  }
  const updateClinicInfo = (data)=>{
        setClinicInfo(data)
        settingsService.updateClinic(clinicId,data)
        .then(res=>{
            toast.success("Updated",{
                position:"bottom-right"
            })
        })
        .catch(err=>{
            toast.error("Error While updating Clinic",{
                position:"bottom-right"
            })
        })
  }
 
  
  return (
    <>
        <div className="row mb-4">
            <div className="col-12">
                <div className="d-flex justify-content-between">
                    <h1>Clinic Info</h1>
                    <div>
                        {isEditing?
                       <>
                        <button className="btn btn-warning me-3" onClick={()=>setIsEditing(!isEditing)}>Cancel</button>
                        
                        </>
                        :
                       
                         <button className="btn btn-icon btn-secondary" onClick={()=>setIsEditing(!isEditing)}><i className="bi bi-pencil"></i></button>
                        }
                    </div>
                      </div>
            </div>
        </div>
        <div className="separator border-2 my-5"></div>
        {isLoading?<Loading/> : <>
            {isEditing ? <ClinicInfoForm clinicInfo={clinicInfo} updateInfo={updateClinicInfo}/> : <ClinicInfoText clinicInfo={clinicInfo} /> }
        </>}

       
    </>
  )
}

export default ClinicInfo